import { FC, forwardRef } from "react";
import { SwitchProps } from "@mui/material";

import SwitchRoot from "./SwitchRoot";

interface IProps extends SwitchProps {
    checkedColor?: "dark" | "primary" | "secondary" | "error" | "info" | "success" | "warning" | "default";
}

const Switch = forwardRef<HTMLButtonElement, IProps>(({ checkedColor, ...rest }, ref) => {
    return(
        <SwitchRoot {...rest} ref={ref} ownerState={{ checkedColor, disabled: rest.disabled, checked: rest.checked }} />
    )
});

Switch.defaultProps = {
    checkedColor: "dark",
};

export default Switch;
